var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 80",
    focusable: "false",
    "aria-hidden": "true",
    className: "svg-inline--bi ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90CDFE",
    d: "M120 75.246c0 1.901-16.954 3.443-37.869 3.443-20.914 0-37.869-1.542-37.869-3.443s16.955-3.443 37.87-3.443c20.914 0 37.868 1.542 37.868 3.443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB072",
    d: "M101.954 40.52a3.33 3.33 0 002.667-3.106l1.609-31.767c-.353-1.81-2.091-2.988-3.885-2.633l-54.148 10.73 15.018 34.453 38.739-7.677z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0000A4",
    d: "M105.246 52.238l-37.15 7.364-4.784-10.98-15.038-34.506L42.122 0l-13.16 2.608a4.202 4.202 0 00-3.31 4.917 4.166 4.166 0 004.906 3.287l6.564-1.301 23.161 53.148a8.214 8.214 0 014.33-2.366c4.488-.89 8.84 2.062 9.722 6.592l24.38-4.832c-.881-4.531 2.043-8.925 6.53-9.815"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB072",
    d: "M67.038 71.641a3.344 3.344 0 11-1.29-6.561 3.344 3.344 0 011.29 6.561m-2.255-11.483a8.312 8.312 0 00-4.37 2.366 8.347 8.347 0 00-2.222 7.447 8.36 8.36 0 106.592-9.813m42.583 2.632a3.344 3.344 0 11-1.29-6.563 3.344 3.344 0 011.29 6.562m-2.255-11.483a8.36 8.36 0 103.222 16.406 8.36 8.36 0 00-3.222-16.406"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED",
    d: "M106.058 56.13a3.443 3.443 0 101.328 6.757 3.443 3.443 0 00-1.328-6.756M65.73 64.983a3.442 3.442 0 101.327 6.756 3.442 3.442 0 00-1.327-6.756"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0000A4",
    d: "M11.68 24.59h16.967c1.562 0 2.828-1.321 2.828-2.95 0-1.63-1.266-2.951-2.828-2.951H11.68c-1.561 0-2.828 1.32-2.828 2.95 0 1.63 1.267 2.951 2.828 2.951m16.968 22.623H11.68c-1.562 0-2.828 1.321-2.828 2.95 0 1.631 1.266 2.952 2.828 2.952h16.968c1.561 0 2.827-1.32 2.827-2.951 0-1.63-1.266-2.95-2.827-2.95m8.799-13.771H2.881C1.29 33.443 0 34.763 0 36.393c0 1.63 1.29 2.951 2.88 2.951h34.567c1.591 0 2.88-1.32 2.88-2.95 0-1.63-1.289-2.951-2.88-2.951"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ad79173f0d9be2e4040825ca4bb9dff9.svg";
export { ForwardRef as ReactComponent };